// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  baseUrl: './api/',
  alias: {
    'app.colnutricionistaslp.com.ar': 'colnutri',
    'colnutri.tres-erres.com.ar': 'colnutri',
    '192.168.50.41': 'colnutri',
    'delta.tres-erres.com.ar': 'delta',
    'localhost': 'delta',
    'imagenes.centrogallegoba.com.ar': 'delta',
    '192.168.5.8': 'delta',
    'hostal.tres-erres.com.ar': 'delta',
    'imagenes.cnbelgrano.com.ar': 'delta',
    '8b010a143e7b.sn.mynetname.net': 'delta',
    'www.deltasis.com.ar': 'delta',
    'moreno.deltasis.com.ar': 'delta',
    'im.alcorta.com.ar': 'delta',
    'clinicasanvicente.ddns.net': 'delta',
    'demo.deltasis.com.ar': 'delta',
    'cpsv.deltasis.com.ar': 'delta',
    '192.168.0.31': 'delta',
    'estudios.meganlp.com.ar': 'delta',
    'imagenes.clinicasanvicente.com.ar': 'delta',
    'imagenes.clinicamodelo-sa.com.ar': 'delta',
    'cmsa.tres-erres.com.ar': 'delta',
    'adrogue.rda.com.ar': 'delta',
    'estudios.rda.com.ar': 'delta',
    'estudios.spmadero.com' : 'delta',
    '192.168.1.180' : 'delta',
    '192.1.1.240' : 'delta',
    '192.1.1.237' : 'delta',
    'estudios.diagnosticotesla.com' : 'delta',
    'imagenes.rosendogarcia.com.ar' : 'delta',
    'test.deltasis.com.ar' : 'delta',
    'imagenesquilmes.redbasa.com.ar' : 'delta',
    'hvideladorna.deltasis.com.ar' : 'delta',
    'imagenessanjuan.redbasa.com.ar' : 'delta',
    'mmater.tres-erres.com.ar' : 'delta',
    'mmater.deltasis.com.ar' : 'delta',
    'imagenesmujer.deltasis.com.ar' : 'delta',
    'estudios.consultoriossantafe.com.ar' : 'delta',
    'imagenesavellaneda.redbasa.com.ar' : 'delta',
    'cloud.deltasis.com.ar' : 'delta',
    'belgrano.deltasis.com.ar' : 'delta',
    'imagenesima.deltasis.com.ar' : 'delta',
    'sanparque.deltasis.com.ar' : 'delta',
    '172.20.98.143' : 'delta',
    '192.168.5.35' : 'delta',
    'estudios.sanatoriodelparque.com.ar' : 'delta',
    'estudios.tiscorniaditac.com.ar' : 'delta',
    '192.168.5.37' : 'delta',
    '192.168.27.229' : 'delta',
    'estudios.lassallediagnostico.com.ar' : 'delta',
    'estudios.nuevaimagensa.com' : 'delta',
    'nuevaimagensa.deltasis.com.ar' : 'delta',
    'estudios.dasimagenes.com.ar' : 'delta',
    'estudios.sanatorioimm.com.ar' : 'delta',
    'sanjose.deltasis.com.ar' : 'delta',
    'en.deltasis.com.ar' : 'delta',
    'portaldeimagenes.sanatorioimm.com.ar' : 'delta',

  },
  'colp': {
    app: {
      title: 'Circulo Odontológico de La Pampa',
      addUrl: '', // Adicional se pasa como base de ruta?...
      imgFondo: '/assets/img/nutricionistas-1.jpg',
      imgLogo: '/assets/img/logoColNutri.png',
      nombreApp: 'Administrador Círculo Odontológico'
    },
    baseUrl: 'https://colp.org.ar/facturacion-colegios/'
  },
  'colnutri': {
    firebase: {
      apiKey: 'AIzaSyDmk7vYtLgyipDEngRS0sim4QmEVAN8IR8',
      authDomain: 'tr-colnutri.firebaseapp.com',
      databaseURL: 'https://tr-colnutri.firebaseio.com',
      projectId: 'tr-colnutri',
      storageBucket: '',
      messagingSenderId: '134219950077',
      appId: '1:134219950077:web:dbb647d35267539978db94'
    },
    app: {
      title: 'Colegio de Nutricionistas de La Pampa',
      addUrl: '', // Adicional se pasa como base de ruta?...
      imgFondo: '/assets/img/nutricionistas-1.jpg',
      imgLogo: '/assets/img/logoColNutri.png',
      imgLogochico: '/assets/img/colnutri.jpg',
      nombreApp: 'Administrador Colegio de Nutricionistas'
    },
    baseUrl: 'https://colnutri.tres-erres.com.ar/colnutri/'
  },
  'delta': {
    firebase: {
      apiKey: 'AIzaSyADsij_GYj5kCe-i00hpFB3KRv4RgZAQI8',
      authDomain: 'delta-sistemas-imagenes.firebaseapp.com',
      databaseURL: 'https://delta-sistemas-imagenes.firebaseio.com',
      projectId: 'delta-sistemas-imagenes',
      storageBucket: 'delta-sistemas-imagenes.appspot.com',
      messagingSenderId: '969702911326',
      appId: '1:969702911326:web:cc7aa5db86108de20c73cf'
    },
    app: {
      title: 'Delta Pacs System',
      addUrl: '', // Adicional se pasa como base de ruta?...
      imgFondo: '/assets/img/delta-1.jpg',
      imgLogo: '/assets/img/logoDelta2.png',
      imgLogochico: '/assets/img/delta.jpg',
      nombreApp: 'Delta Sistemas'
    },
    baseUrl: './api/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
